import {SpinnerService} from "../../modules/SpinnerModule";

export 
function ListController(hubProxyFactory, $spinner:SpinnerService) {
    var vm = this;
    const dataHub = hubProxyFactory.create('dataHub');
    vm.assets = [];
    vm.searchText = null;

    function stateChanged(e) {
        vm.assets = [];
        if (e.newState !== 1) return;
        vm.refresh();
    }

    dataHub.on('assetUpdated', (e) => vm.assets.merge(e, x => x.guid));
    dataHub.on('assetRemoved', (e) => vm.assets.remove(e, x => x.guid));
    dataHub.stateChanged(stateChanged);
    $spinner.show('Starting');
    dataHub.start()
        .finally($spinner.hide);

    vm.refresh = () => {
        vm.assets = [];
        dataHub.invoke('assetSearch', vm.searchText);
    };

    vm.loadReport = (reportName) => {
        vm.assets = [];
        $spinner.show('Reporting');
        dataHub.invoke('assetReport', reportName)
            .finally($spinner.hide);
    };
  
}
